// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homePageSwiper {
  margin-bottom: 1rem !important ; 
  min-height: 100% !important ;   
}
.homePageSwiper.swiper {
    width: 100%;
    height: auto;
    overflow: revert !important;
}

.homePageSwiper .swiper-button-prev,
.homePageSwiper .swiper-button-next {
    top: 0;
    color: #fff;
    z-index: 3;
    height: 100%;
}

.homePageSwiper .swiper-button-prev::after,
.homePageSwiper .swiper-button-next::after {
    font-size: 22px;
    font-weight: bold;
}

.homePageSwiper .swiper-button-prev.swiper-button-disabled {
    /* pointer-events: stroke !important; */
    opacity: 0.3 !important;
    pointer-events: none !important;
}

.homePageSwiper .swiper-button-next.swiper-button-disabled {
    opacity: 0.3 !important;
    pointer-events: none !important;
}

/* Ensure navigation buttons are always visible when enabled */
.homePageSwiper .swiper-button-prev:not(.swiper-button-disabled),
.homePageSwiper .swiper-button-next:not(.swiper-button-disabled) {
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: auto !important;
}

/* Custom navigation buttons for specific sections - keeping original sizes */
.swiper-button-prev[class*="swiper-button-prev-"],
.swiper-button-next[class*="swiper-button-next-"] {
    position: absolute;
    top: 0;
    margin-top: 0;
    color: #fff !important;
    z-index: 10;
    height: 100%;
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: auto !important;
}

.swiper-button-prev[class*="swiper-button-prev-"]::after,
.swiper-button-next[class*="swiper-button-next-"]::after {
    font-size: 22px;
    font-weight: bold;
}

.swiper-button-prev[class*="swiper-button-prev-"]:hover,
.swiper-button-next[class*="swiper-button-next-"]:hover {
    opacity: 0.7 !important;
}

.homePageSwiper.navigationMedium .swiper-button-next {
    left: 300px;
}

.homePageSwiper.navigationMedium .swiper-button-prev {
    left: 250px;
}

.homePageSwiper.navigationBiggest .swiper-button-next {
    left: 444px;
}

.homePageSwiper.navigationBiggest .swiper-button-prev {
    left: 385px;
}

.homePageSwiper.navigationSmall .swiper-button-next {
    left: 150px;
}

.homePageSwiper.navigationSmall .swiper-button-prev {
    left: 95px;
}

.homePageSwiper .swiper-slide {
    width: 100%;
    height: auto; /* let content/aspect ratio dictate height */
    min-height: 0; /* allow shrinking in Safari */
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    z-index: 0;
}

/* Orientation-aware override: remove fixed height when landscape mode is active */
.homePageSwiper.landscape-mode .swiper-slide {
    height: auto !important;
    min-height: 0 !important;
}

/* Ensure inner containers can size naturally in landscape mode */
.homePageSwiper.landscape-mode .gridCategoryItems {
    height: auto !important;
}

/* Prevent zero-height collapses for inner orientation containers (helps LazyLoad/IO to trigger) */
.homePageSwiper .swiper-slide .orientation-container {
    min-height: 1px;
}

.homePageSwiper .swiper-slide-active .homeSwiperContainer {
    left: 20px;
}

.homePageSwiper .swiper-slide:hover .homeSwiperContainer {
    visibility: visible;
    transform: scale(1.2);
    transition: all 0.4s ease-in-out;
    transition-delay: 0.2s;
}

.homePageSwiper .swiper-slide:hover {
    z-index: 2;
}

.homePageSwiper.categorySizeSmall .swiper-slide {
    height: 170px !important;
}

.homePageSwiper.categorySizeSmall .swiper-slide:hover .categoryHover {
    transform: scale(1.1);
}

.homePageSwiper.categorySizeSmall .swiper-slide:hover .categoryHover {
    transform: scale(1.1);
    border-radius: 5px;
}

.homePageSwiper.livestream .swiper-slide {
    height: auto !important;
    text-align: center;
    font-size: 18px;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
}

.homePageSwiper .moreLike .swiper-slide {
    height: auto;
    text-align: center;
    font-size: 18px;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    object-fit: cover;
}

.homePageSwiper.livestream .swiper-slide:hover .categoryHover {
    transform: scale(1.1);
}

.homeSwiperContainer {
    position: absolute;
    min-height: 100%;
    width: 250px;
    background-color: #16181f;
    top: 5px;
    left: 0;
    transition: transform 0.04s linear;
    visibility: hidden;
    overflow: hidden;
    border-radius: 5px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.homeSwiperContainer.theme-two-active,
.hoverCardContainer.theme-two-active {
    padding: 13px !important;
}

.homeSwiperContainer.theme-two-active::before,
.hoverCardContainer.theme-two-active::before {
    background-image: none;
}

.homeSwiperContainer.theme-two-active .homeListImage::after,
.hoverCardContainer.theme-two-active .homeListImage::after {
    background: none;
}

.homeSwiperContainer.theme-two-active .homePageCardHeading.active,
.hoverCardContainer.theme-two-active .homePageCardHeading.active {
    width: 50px;
}

.homeSwiperContainer .dropdown-item:hover,
.homeSwiperContainer .dropdown-item:focus,
.hoverCardContainer .dropdown-item:hover,
.hoverCardContainer .dropdown-item:focus {
    background-color: transparent;
}

.homeSwiperContainer::before {
    position: absolute;
    content: "";
    background-image: linear-gradient(to bottom, transparent, #16181f, #16181f);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

@media screen and (min-width: 991px) {
    .homePageSwiper .swiper-slide {
        height: auto !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Swiper.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;;IAEI,MAAM;IACN,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA,8DAA8D;AAC9D;;IAEI,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA,6EAA6E;AAC7E;;IAEI,kBAAkB;IAClB,MAAM;IACN,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY,EAAE,4CAA4C;IAC1D,aAAa,EAAE,8BAA8B;IAC7C,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA,kFAAkF;AAClF;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA,iEAAiE;AACjE;IACI,uBAAuB;AAC3B;;AAEA,kGAAkG;AAClG;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,QAAQ;IACR,OAAO;IACP,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;;;IAII,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,2EAA2E;IAC3E,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".homePageSwiper {\n  margin-bottom: 1rem !important ; \n  min-height: 100% !important ;   \n}\n.homePageSwiper.swiper {\n    width: 100%;\n    height: auto;\n    overflow: revert !important;\n}\n\n.homePageSwiper .swiper-button-prev,\n.homePageSwiper .swiper-button-next {\n    top: 0;\n    color: #fff;\n    z-index: 3;\n    height: 100%;\n}\n\n.homePageSwiper .swiper-button-prev::after,\n.homePageSwiper .swiper-button-next::after {\n    font-size: 22px;\n    font-weight: bold;\n}\n\n.homePageSwiper .swiper-button-prev.swiper-button-disabled {\n    /* pointer-events: stroke !important; */\n    opacity: 0.3 !important;\n    pointer-events: none !important;\n}\n\n.homePageSwiper .swiper-button-next.swiper-button-disabled {\n    opacity: 0.3 !important;\n    pointer-events: none !important;\n}\n\n/* Ensure navigation buttons are always visible when enabled */\n.homePageSwiper .swiper-button-prev:not(.swiper-button-disabled),\n.homePageSwiper .swiper-button-next:not(.swiper-button-disabled) {\n    opacity: 1 !important;\n    visibility: visible !important;\n    pointer-events: auto !important;\n}\n\n/* Custom navigation buttons for specific sections - keeping original sizes */\n.swiper-button-prev[class*=\"swiper-button-prev-\"],\n.swiper-button-next[class*=\"swiper-button-next-\"] {\n    position: absolute;\n    top: 0;\n    margin-top: 0;\n    color: #fff !important;\n    z-index: 10;\n    height: 100%;\n    opacity: 1 !important;\n    visibility: visible !important;\n    pointer-events: auto !important;\n}\n\n.swiper-button-prev[class*=\"swiper-button-prev-\"]::after,\n.swiper-button-next[class*=\"swiper-button-next-\"]::after {\n    font-size: 22px;\n    font-weight: bold;\n}\n\n.swiper-button-prev[class*=\"swiper-button-prev-\"]:hover,\n.swiper-button-next[class*=\"swiper-button-next-\"]:hover {\n    opacity: 0.7 !important;\n}\n\n.homePageSwiper.navigationMedium .swiper-button-next {\n    left: 300px;\n}\n\n.homePageSwiper.navigationMedium .swiper-button-prev {\n    left: 250px;\n}\n\n.homePageSwiper.navigationBiggest .swiper-button-next {\n    left: 444px;\n}\n\n.homePageSwiper.navigationBiggest .swiper-button-prev {\n    left: 385px;\n}\n\n.homePageSwiper.navigationSmall .swiper-button-next {\n    left: 150px;\n}\n\n.homePageSwiper.navigationSmall .swiper-button-prev {\n    left: 95px;\n}\n\n.homePageSwiper .swiper-slide {\n    width: 100%;\n    height: auto; /* let content/aspect ratio dictate height */\n    min-height: 0; /* allow shrinking in Safari */\n    background: transparent;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 6px;\n    z-index: 0;\n}\n\n/* Orientation-aware override: remove fixed height when landscape mode is active */\n.homePageSwiper.landscape-mode .swiper-slide {\n    height: auto !important;\n    min-height: 0 !important;\n}\n\n/* Ensure inner containers can size naturally in landscape mode */\n.homePageSwiper.landscape-mode .gridCategoryItems {\n    height: auto !important;\n}\n\n/* Prevent zero-height collapses for inner orientation containers (helps LazyLoad/IO to trigger) */\n.homePageSwiper .swiper-slide .orientation-container {\n    min-height: 1px;\n}\n\n.homePageSwiper .swiper-slide-active .homeSwiperContainer {\n    left: 20px;\n}\n\n.homePageSwiper .swiper-slide:hover .homeSwiperContainer {\n    visibility: visible;\n    transform: scale(1.2);\n    transition: all 0.4s ease-in-out;\n    transition-delay: 0.2s;\n}\n\n.homePageSwiper .swiper-slide:hover {\n    z-index: 2;\n}\n\n.homePageSwiper.categorySizeSmall .swiper-slide {\n    height: 170px !important;\n}\n\n.homePageSwiper.categorySizeSmall .swiper-slide:hover .categoryHover {\n    transform: scale(1.1);\n}\n\n.homePageSwiper.categorySizeSmall .swiper-slide:hover .categoryHover {\n    transform: scale(1.1);\n    border-radius: 5px;\n}\n\n.homePageSwiper.livestream .swiper-slide {\n    height: auto !important;\n    text-align: center;\n    font-size: 18px;\n    background: transparent;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 6px;\n}\n\n.homePageSwiper .moreLike .swiper-slide {\n    height: auto;\n    text-align: center;\n    font-size: 18px;\n    background: transparent;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 6px;\n    object-fit: cover;\n}\n\n.homePageSwiper.livestream .swiper-slide:hover .categoryHover {\n    transform: scale(1.1);\n}\n\n.homeSwiperContainer {\n    position: absolute;\n    min-height: 100%;\n    width: 250px;\n    background-color: #16181f;\n    top: 5px;\n    left: 0;\n    transition: transform 0.04s linear;\n    visibility: hidden;\n    overflow: hidden;\n    border-radius: 5px;\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.homeSwiperContainer.theme-two-active,\n.hoverCardContainer.theme-two-active {\n    padding: 13px !important;\n}\n\n.homeSwiperContainer.theme-two-active::before,\n.hoverCardContainer.theme-two-active::before {\n    background-image: none;\n}\n\n.homeSwiperContainer.theme-two-active .homeListImage::after,\n.hoverCardContainer.theme-two-active .homeListImage::after {\n    background: none;\n}\n\n.homeSwiperContainer.theme-two-active .homePageCardHeading.active,\n.hoverCardContainer.theme-two-active .homePageCardHeading.active {\n    width: 50px;\n}\n\n.homeSwiperContainer .dropdown-item:hover,\n.homeSwiperContainer .dropdown-item:focus,\n.hoverCardContainer .dropdown-item:hover,\n.hoverCardContainer .dropdown-item:focus {\n    background-color: transparent;\n}\n\n.homeSwiperContainer::before {\n    position: absolute;\n    content: \"\";\n    background-image: linear-gradient(to bottom, transparent, #16181f, #16181f);\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n@media screen and (min-width: 991px) {\n    .homePageSwiper .swiper-slide {\n        height: auto !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
